import { Texture } from "pixi.js";
import { CommonResourcesPackage } from "../../../resources/CommonResourcesPackage";

export class ShieldPartsTexturePack {
    public readonly textures: Texture[];
    
    public constructor(commonResources: CommonResourcesPackage) {
        this.textures = this.extractTextures(commonResources);
    }

    private extractTextures(commonResources: CommonResourcesPackage): Texture[] {
        return [
            commonResources.assets_common_ui_shield_parts_shield_01_png,
            commonResources.assets_common_ui_shield_parts_shield_02_png,
            commonResources.assets_common_ui_shield_parts_shield_03_png,
            commonResources.assets_common_ui_shield_parts_shield_04_png,
            commonResources.assets_common_ui_shield_parts_shield_05_png
        ];
    }
}